import React from 'react';

import Image from '@/components/Image/Image';

import useOnConnectClick from '../../DevicesPage/hooks/useOnConnectClick';

const SelectDeviceItem = (props) => {
    const {image, name, type} = props;
    const handleOnConnectClick = useOnConnectClick(type);

    return (
        <li
            role='button'
            onClick={handleOnConnectClick}
            className='flex w-full flex-row items-center gap-4 rounded-xl border border-primary-dark-30 bg-white px-4 py-4 ml:flex-col ml:rounded-[24px] ml:border-0 ml:px-8 ml:py-8'
        >
            <div>
                <Image className='h-[64px] w-[64px] ml:h-auto ml:w-full' src={image} alt={name} aria-hidden />
            </div>
            <p
                secondary
                light
                className='mt-0 w-full text-left text-16 font-bold leading-[36px] text-primary-dark ml:max-w-66 ml:text-center ml:text-24 rtl:text-right'
            >
                {name}
            </p>
        </li>
    );
};

export default SelectDeviceItem;
